<template>
  <div>
    <div class="product-container">
      <Bread first-name="系统平台" metertype="NB物联网管理平台"></Bread>
      <el-tag effect="dark">NB物联网管理平台</el-tag>
      <div class="sys-synopsis">NB物联网管理平台支持多平台多产品管理，OneNet平台，Wing平台多物联网平台同时管理</div>
      <el-tag effect="dark">系统功能简介</el-tag>
      <div class="sys-synopsis">
        <div>产品管理：对不同的产品进行管理 ；</div>
        <div>设备管理： 对不同产品下的设备进行管理；</div>
        <div>区域管理： 对客户所在的区域进行管理；</div>

        <div>系统报表： 包括缴费统计，设备历史记录，警告记录等；</div>
        <div>系统设置： 主要有系统用户管理，菜单管理，角色管理，接口管理，字典管理等；</div>
      </div>
      <el-tag effect="dark">系统特点简介</el-tag>
      <div class="sys-synopsis">
        <p>安全性： 数据管理服务器、远程通讯管理服务器和终端用户管理软件分离设计，保证数据安全，完整的权限系统，支持修改各个角色的权限；</p>
        <p>便捷性： 快捷操作，支持数据快速填入，便于操作员操作；</p>
        <p>扩展性： 可以根据用户的要求对系统进行定制开发，终端软件远程升级，以满足不同用户的各项新增需求；</p>
      </div>
      <div class="system-img">
        <img src="@/svg/nb_1.png" />
      </div>
      <div class="system-img">
        <img src="@/svg/nb_2.png" />
      </div>
      <div class="system-img">
        <img src="@/svg/nb_3.png" />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
.product-container {
  .el-tag {
    margin-top: 20px;
    height: 40px;
    font-size: 20px;
  }
  .sys-synopsis {
    line-height: 35px;
    letter-spacing: 2px;
    text-indent: 2cm;
    padding: 12px 0;
    font-size: 18px;
  }
  .system-img {
    height: 670px;
    width: 1150px;
    padding-top: 50px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
